/**
 * created by lei lei on 2020/6/5
 * 自定义编辑器
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Editor from './Editor'
import {Input, Row, Col, Button, message} from 'antd';
import OrdinaryTrees from './OrdinaryTrees'
import {GetQueryValue} from "../../../utils";
import './customEditor.css'
import {Scrollbars} from "react-custom-scrollbars";
import $ from 'jquery';
import {EDITOR_DOMAIN_NAME_URL} from "../../../constants";

export default class CustomEditor extends Component {
    static defaultProps = {
        customHeight: 500,//编辑器的高度，自定义高度，默认500
    }
    static propTypes = {
        customHeight: PropTypes.number,//自定义编辑器的高度
    }

    constructor(props) {
        super(props);
        this.state = {
            title: '',//标题
            fromSource: '',//来源
            columnInformation: '',//整条栏目的数据
            columName: '',//栏目名称
            content: '',//文本编辑器的内容
            dataSource: [],
            showStatue: false,//是否显示栏目选择框
            isUpDate: false,//是否更新子组件，回调函数不加，组组件会无线进入死循环，消耗内存，报错，这个为了解决子组件报错
            loading:false//是否点击了暂存，然后显示保存中
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.initData()
        this.getColumn()
    }


    //获取内容初始参数
    initData() {
        let params = GetQueryValue('url')
        let url = EDITOR_DOMAIN_NAME_URL+"/static/api/categories?url=" + params;
        fetch(url, {
            method: 'get',
            /*   cache: 'no-cache',
               headers: headers,
               credentials: 'include'*/
        }).then(response => response.json()).then(data => {
            if (data && data.status === 0) {
                this.setState({
                    title: data.title ? data.title : '',
                    fromSource: data.source ? data.source : '',
                    content: data.content ? data.content : '',
                    isUpDate: true
                })
            } else {
                message.warning('获取数据失败！')
            }
        }).catch((error) => {
            console.error(error);
        })
    }

    //获取栏目数据
    getColumn() {
        let url = "/cm-sites-pms/website/filterCheckedColumn";
        fetch(url, {
            method: 'post',
            /*   cache: 'no-cache',
               headers: headers,
               credentials: 'include'*/
        }).then(response => response.json()).then(data => {
            this.addPrimaryKey(data);
            this.setState({
                dataSource: data
            })
            console.log(data)
        }).catch((error) => {
            console.error(error);
        })
    }

    addPrimaryKey = (data) => {
        data && data.map(item=>{
            item.keyId = "_"+item.owner + "_" + item.treeContentId;
            this.addPrimaryKey(item.subtree);
        })
    }


    render() {
        return (
            <div className={'CustomEditor'} >
                <div style={{background: 'white', paddingTop:10,paddingLeft:10,paddingRight:10,}}>
                    <Row>
                        <Col span={2}>
                            <div style={{height: 32, lineHeight: '32px', textAlign: 'center'}}>标题：</div>
                        </Col>
                        <Col span={5} style={{}}> <Input value={this.state.title}
                                                         style={{color: 'black', width: '100%'}}
                                                         onMouseLeave={() => {
                                                             this.setState({showStatue: false, isUpDate: false})
                                                         }} onChange={(e) => {
                            this.setState({title: e.target.value})
                        }} placeholder="请输入标题"/></Col>
                        <Col span={2}>
                            <div style={{height: 32, lineHeight: '32px', textAlign: 'center'}}>栏目：</div>
                        </Col>
                        <Col span={5} style={{}}> <Input style={{color: 'black', width: '100%'}} disabled={true}
                                                         value={this.state.columName}
                                                         onMouseOver={() => {
                                                             this.setState({showStatue: true, isUpDate: false})
                                                         }} placeholder="请选择栏目"/>
                            {this.state.showStatue ? <div onMouseLeave={() => {
                                 this.setState({showStatue: false, isUpDate: false})
                            }} style={{
                                position: 'absolute', width: 350,
                                background: 'white', height: 260, padding: 10,
                                zIndex: 10000, border: '1px solid #ececec'
                            }}>
                                <Scrollbars>
                                    <OrdinaryTrees
                                        dataSource={this.state.dataSource}
                                        title={'treeName'}
                                        keyId={'treeid'}
                                        children={'subtree'}
                                        checkable={false}
                                        showSearch={true}
                                        checkedKeysAll={(data) => {
                                            console.log(data)
                                            this.setState({
                                                showStatue: false,
                                                columName: data.name,
                                                columnInformation: data
                                            })
                                            // console.log('选中的数据源', data)
                                        }}
                                    />
                                </Scrollbars>
                            </div> : null}

                        </Col>
                        <Col span={2}>
                            <div style={{height: 32, lineHeight: '32px', textAlign: 'center'}}>来源：</div>
                        </Col>
                        <Col span={5} style={{}}> <Input value={this.state.fromSource} onMouseLeave={() => {
                            this.setState({showStatue: false, isUpDate: false})
                        }} style={{color: 'black', width: '100%'}} onChange={(e) => {

                            this.setState({fromSource: e.target.value})
                        }} placeholder="请输入来源"/></Col>
                        <Col span={3}>
                            <Button style={{marginLeft:20,height:30}}  type="primary"
                                    loading={this.state.loading}
                                    onClick={() => {
                                this.submit()
                            }}size={'large'} >暂存</Button>

                        </Col>

                    </Row>
                    <div style={{marginTop: 10}}>
                        <Editor
                            customHeight={this.props.customHeight}
                            content={this.state.content}
                            isUpDate={this.state.isUpDate}
                            callBackeditorContent={(data) => {
                                // console.log(data)
                                this.setState({content: data, isUpDate: false})
                            }}
                        />
                    </div>
                </div>
            </div>
        )
    }

    getByOwner(owner, callBack){
        let url = "/cm-sites-pms/media/getByOwner?owner="+owner;
        fetch(url, {
            method: 'post',
            /*   cache: 'no-cache',
               headers: headers,
               credentials: 'include'*/
        }).then(response => response.json()).then(data => {
            callBack(data);
        }).catch((error) => {
            this.setState({
                loading:false
            });
            message.error("保存失败，owner:"+owner+"；无法获取媒体信息");
            console.error(error);
        })
    }

    submit() {
        if(this.state.columnInformation && this.state.columnInformation.owner){
            message.info("保存中，请稍后!");
            this.setState({
                loading:true
            });
            this.getByOwner(this.state.columnInformation.owner, (media)=>{
                this.state.columnInformation.mediaName = media.name;
                this.state.columnInformation.mainColumn = 1;//标识为主栏目
                let body = {
                    title: this.state.title,
                    source: this.state.fromSource,
                    storySyncColumns: JSON.stringify([this.state.columnInformation]),
                    dataSource: 1,//写稿
                    wbweight: 10,//默认10
                    statusName: "草稿",
                    content: this.state.content,
                    currentMediaCode:media.code,
                    mediaCode:media.code,
                    mediaName:media.name
                }
                let url = "/cm-sites-pms/storyNew/save";
                $.post(url, body, (data)=>{
                    this.setState({
                        loading:false
                    });
                    message.success("保存成功!");
                },"json");
            });
        }else{
            message.error("保存失败，请选择栏目。");
        }
    }
}